import { GoldDiamond } from "@/components/Reveal";
import { useLang } from "@/lib/lang";

export default function Marquee() {
  const { t } = useLang();
  return (
    <div data-testid="editorial-marquee" className="marquee-hover relative overflow-hidden border-b border-hairline bg-white py-5" aria-hidden="true">
      <div className="flex w-max animate-marquee items-center gap-10 pr-10">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center gap-10" aria-hidden={copy === 1}>
            {t.marquee.map((item) => (
              <span key={item} className="flex items-center gap-10 whitespace-nowrap font-mono text-[11px] uppercase tracking-[0.3em] text-navy/55">
                {item}
                <GoldDiamond />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
